import * as React from 'react';

import { EnterpriseOrgScopedPageGuard } from 'bundles/unified-common/providers/org-scoped/guards/EnterpriseOrgScopedPageGuard';
import { EnterpriseOrgScopedUserStateCheckWrapper } from 'bundles/unified-common/providers/org-scoped/guards/EnterpriseOrgScopedUserStateCheckWrapper';
import EnterpriseOrgScopedHeaderFooterWrapper from 'bundles/unified-common/providers/org-scoped/layout/EnterpriseOrgScopedHeaderFooterWrapper';
import { EnterpriseOrgScopedPageExtras } from 'bundles/unified-common/providers/org-scoped/layout/EnterpriseOrgScopedPageExtras';
import OrganizationPageTrackingWrapper from 'bundles/unified-home-common/pages/org-scoped/OrganizationPageTrackingWrapper';

type Props = {
  // Forwarded to OrganizationPageTrackingWrapper. Set by pages that render their own metatags (e.g. XDPs)
  // so the org name isn't also emitted as the tab title.
  hasOwnMetatags?: boolean;
  // Hides the admin impersonation preview banner from the header/footer wrapper (e.g. on XDPs).
  hideAdminImpersonationBanner?: boolean;
};

const EnterpriseOrgScopedPageTemplateWrapper = ({
  children,
  hasOwnMetatags,
  hideAdminImpersonationBanner,
}: React.PropsWithChildren<Props>) => {
  return (
    <EnterpriseOrgScopedPageGuard>
      <EnterpriseOrgScopedPageExtras>
        <EnterpriseOrgScopedHeaderFooterWrapper hideAdminImpersonationBanner={hideAdminImpersonationBanner}>
          <EnterpriseOrgScopedUserStateCheckWrapper>
            <OrganizationPageTrackingWrapper hasOwnMetatags={hasOwnMetatags}>
              {children}
            </OrganizationPageTrackingWrapper>
          </EnterpriseOrgScopedUserStateCheckWrapper>
        </EnterpriseOrgScopedHeaderFooterWrapper>
      </EnterpriseOrgScopedPageExtras>
    </EnterpriseOrgScopedPageGuard>
  );
};

export default EnterpriseOrgScopedPageTemplateWrapper;
